<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <div class="title">云宝向{{ data.shopTitle }}</div>
    <div class="title">投递了一封信</div>
    <div><span class="font_color">{{ data.fullYear }}&nbsp;</span>年<span class="font_color">&nbsp;{{ data.fullMonth }}&nbsp;</span>月<span class="font_color">&nbsp;{{ data.fullDay }}&nbsp;</span>日你与云短信相遇</div>
    <div>今年店铺总会员数达：<span class="font_color">{{ data.customerNumNowYear }}&nbsp;</span>人</div>
    <div>今年成交客户总数为：<span class="font_color">{{ data.newPayNum }}&nbsp;</span>人</div>
    <div>今年新加入店铺会员数为：<span class="font_color">{{ data.newMemberNum }}&nbsp;</span>人</div>
    <div style="margin-top: 30px;">始终相信，</div>
    <div>会员运营就是积累财富的过程</div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    },
    
    data: {
      type: Object,
      default: ()=> {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}
.view_box {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 50px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  font-family: PingFang SC;
  background-image: url("../../assets/images/yearReport/P1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // animation: view_box_s 1.5s ease-in;
  // animation-fill-mode: both;

  div {
    font-family: PingFang SC;
    width: 100%;
    margin-bottom: 12px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;

    &:nth-child(2) {
      margin: 4px 0 30px;
    }
  }

  .font_color {
    color: #0B79FF;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
